import { EmptyObject } from '../../EmptyObject';

export const ManagementDebugEnableRequest = 'sos.Monitoring.Management.Debug.ManagementDebugEnableRequest';
export interface ManagementDebugEnableRequest {
	type: typeof ManagementDebugEnableRequest;
}

export const ManagementDebugEnableResult = 'sos.Monitoring.Management.Debug.ManagementDebugEnableResult';
export interface ManagementDebugEnableResult {
	type: typeof ManagementDebugEnableResult;
	result: EmptyObject;
}

export const ManagementDebugDisableRequest = 'sos.Monitoring.Management.Debug.ManagementDebugDisableRequest';
export interface ManagementDebugDisableRequest {
	type: typeof ManagementDebugDisableRequest;
}

export const ManagementDebugDisableResult = 'sos.Monitoring.Management.Debug.ManagementDebugDisableResult';
export interface ManagementDebugDisableResult {
	type: typeof ManagementDebugDisableResult;
	result: EmptyObject;
}

export const ManagementDebugIsEnabledRequest = 'sos.Monitoring.Management.Debug.ManagementDebugIsEnabledRequest';
export interface ManagementDebugIsEnabledRequest {
	type: typeof ManagementDebugIsEnabledRequest;
}

export const ManagementDebugIsEnabledResult = 'sos.Monitoring.Management.Debug.ManagementDebugIsEnabledResult';
export interface ManagementDebugIsEnabledResult {
	type: typeof ManagementDebugIsEnabledResult;
	result: boolean;
}

export type ManagementDebugRequests = ManagementDebugEnableRequest | ManagementDebugDisableRequest | ManagementDebugIsEnabledRequest;
